/* Merchant-managed font choices. Older servers retain their existing choices until published. */
(() => {
  if (window.stEngravingFontLibrary) return;
  const origin = 'https://merchant-tools-suite.replit.app';
  const entries = {};
  window.stEngravingFontLibrary = entries;
  let catalog;
  async function getFonts() {
    if (!catalog) catalog = (async () => {
      const response = await fetch(origin + '/api/engraving-fonts', {cache:'no-store'});
      if (response.status === 404) return null; // rollout gate
      if (!response.ok) throw Error('Saved lettering fonts are unavailable. Please reload before ordering.');
      const {fonts} = await response.json();
      if (fonts.length !== 3) throw Error('Lettering options are incomplete. Please contact the store.');
      await Promise.all(fonts.map(async f => {
        const family = 'ST_' + f.id.replace(/-/g,'');
        const face = await new FontFace(family, `url("${origin + f.url}")`).load();
        document.fonts.add(face);
        entries[f.id] = {...f, family, canvas:`400 {s}px "${family}"`};
      }));
      const style=document.createElement('style');
      style.textContent=fonts.map(f=>`.st-pk__panel[data-font="${f.id}"] .st-pk__txt{font-family:"${entries[f.id].family}"!important;font-weight:400!important}`).join('');
      document.head.appendChild(style);
      return fonts;
    })();
    return catalog;
  }
  async function mount(root) {
    if (root.dataset.fontLibrary) return;
    root.dataset.fontLibrary='loading';
    const select=root.querySelector('[data-eng-font]'), grid=root.querySelector('.st-eng__fonts');
    if (!select || !grid) return;
    try {
      const fonts=await getFonts();
      if (!fonts) {root.dataset.fontLibrary='legacy';return;}
      if (!root.isConnected) return;
      const previous=select.value;
      select.replaceChildren();grid.replaceChildren();
      fonts.forEach(f=>{
        select.add(new Option(f.label,f.id));
        const button=document.createElement('button');button.type='button';button.className='st-eng__font';button.dataset.engFontBtn=f.id;
        const sample=document.createElement('span');sample.className='st-eng__font-sample';sample.dataset.engFontSample='';
        sample.textContent=root.querySelector('[data-eng-company]')?.value?.slice(0,24)||'Staten Tools';
        sample.style.fontFamily=entries[f.id].family;sample.style.fontWeight='400';
        const label=document.createElement('span');label.className='st-eng__font-name';label.textContent=f.label;
        button.append(sample,label);grid.appendChild(button);
      });
      select.value=fonts.some(f=>f.id===previous)?previous:fonts[0].id;
      grid.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.engFontBtn===select.value)));
      select.dispatchEvent(new Event('change',{bubbles:true}));
      root.dataset.fontLibrary='ready';
    }catch(error){
      const note=document.createElement('p');note.setAttribute('role','alert');note.textContent=error.message;grid.replaceChildren(note);
      select.disabled=true;
      // Prevent ordering artwork with an unapproved substitute font.
      root.dataset.fontLibrary='error';
    }
  }
  const scan=()=>document.querySelectorAll('[data-st-engraving]').forEach(mount);
  scan();new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});
})();
